/** Paramétrage tarifaire de la plateforme exposé par GET/PATCH /admin/config (SCRUM-80). */
export interface PlatformConfig {
  ratePerKm: number
  baseFare: number
  roundingStep: number
  commissionPct: number
  /** Facturation (SCRUM-92) — période de génération des factures (1..4 semaines). */
  billingPeriodWeeks: number
  /** Plafond de dette (DT) déclenchant la suspension. */
  debtCapDinar: number
  /** Délai de grâce après émission d'une facture (jours). */
  graceAfterInvoiceDays: number
  updatedBy: string | null
  updatedAt: string
}

/** Paliers d'arrondi autorisés (DT) — mêmes bornes que le DTO côté API. */
export const ROUNDING_STEPS = [0.1, 0.25, 0.5, 1] as const

/** Périodes de facturation autorisées (semaines) — borne CHECK SQL 1..4 (SCRUM-92). */
export const BILLING_PERIOD_WEEKS = [1, 2, 3, 4] as const
